import { useEffect } from 'react';
// logos
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';

const ReportSummary = ({ data }) => {

    useEffect(() => {
        // Check if Bootstrap is properly initialized
        if (window.bootstrap) {
            // Initialize tooltips on the page
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipTriggerList.forEach((tooltipTriggerEl) => {
                new window.bootstrap.Tooltip(tooltipTriggerEl); // Use window.bootstrap to access the Tooltip class
            });
        }
    }, []);



    const abnormalList = (data?.data?.smartReportAbnormalListDetails || [])
       // // .filter((item) => item.IsBold === "Yes" && item.IsTrend === "Yes" && item.NeedAttention === "Yes" && item.TestOrder !=='') //item.RangeFlag !== "Done" &&
        // .filter((item) => (
        //         (item.NeedAttention === "Yes" && item.AttentionLevel === '') 
        //         || (item.NeedAttention === "Partial" && item.AttentionLevel === 'Low' && (
        //             parseFloat(item.Result.replace(/[^\w\s\.-]/g, '')) <= parseFloat(item.LowerRange.replace(/[^\w\s\.-]/g, ''))
        //         ))
        //         || (item.NeedAttention === "Partial" && item.AttentionLevel === 'High' && (
        //             parseFloat(item.Result.replace(/[^\w\s\.-]/g, '')) >= parseFloat(item.HighRange.replace(/[^\w\s\.-]/g, ''))
        //         ))
        //     ) && item.TestOrder !=='')
        // .sort((a, b) => {
        //     if (a.TestOrder !== b.TestOrder) {
        //         return a.TestOrder - b.TestOrder;
        //     }
        //     return a.AnalyteOrder - b.AnalyteOrder;
        // });
        // code update according to condition of need attention and high and low attention level
    .filter((item) => {
        const resultValue = parseFloat(item.Result.replace(/[^\w\s\.-]/g, ''));

        const lowerRangeValid = item.LowerRange !== "" && !isNaN(parseFloat(item.LowerRange));
        const higherRangeValid = item.HigherRange !== "" && !isNaN(parseFloat(item.HigherRange));

        const lowerRange = lowerRangeValid ? parseFloat(item.LowerRange.replace(/[^\w\s\.-]/g, '')) : null;
        const higherRange = higherRangeValid ? parseFloat(item.HigherRange.replace(/[^\w\s\.-]/g, '')) : null;

        const condition1 = item.NeedAttention.toUpperCase() == "YES" && (item.AttentionLevel === '' || item.AttentionLevel === null);
        const condition2 = item.NeedAttention.toUpperCase() == "PARTIAL" && item.AttentionLevel.toUpperCase() == 'LOW' && lowerRange !== null && resultValue <= lowerRange;
        const condition3 = item.NeedAttention.toUpperCase() == "PARTIAL" && item.AttentionLevel.toUpperCase() == 'HIGH' && higherRange !== null && resultValue >= higherRange;

        return (condition1 || condition2 || condition3) && item.TestOrder !== '';
    })
    .sort((a, b) => {
        if (a.TestOrder !== b.TestOrder) {
            return a.TestOrder - b.TestOrder;
        }
        return a.AnalyteOrder - b.AnalyteOrder;
    });




    // Chunk the abnormalList into smaller chunks of size 18
    const chunkSize = 25;
    const chunkedAbnormalList = [];

    for (let i = 0; i < abnormalList.length; i += chunkSize) {
        chunkedAbnormalList.push(abnormalList.slice(i, i + chunkSize));
    }

    // Group items by TestName
    // const groupedByPanelName = abnormalList.reduce((acc, item) => {
    //     const { PanelName } = item;
    //     if (!acc[PanelName]) {
    //         acc[PanelName] = [];
    //     }
    //     acc[PanelName].push(item);
    //     return acc;
    // }, {});

    // // Convert the grouped data to an array for rendering
    // const groupedItems = Object.entries(groupedByPanelName);

    

    return (
        <>
            {chunkedAbnormalList.map((chunk, chunkIndex) => (
                <section className="section section-2" key={chunkIndex} id='report-summary'>
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} alt="logo75" />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1 benefits page-padding">
                                <div className="col-12 mb-3">
                                    <h2 className="panel-name">Summary of "Out of range" parameters</h2>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table test-grid">
                                                <thead>
                                                    <tr>
                                                        {/* <th>Test Name</th> */}
                                                        <th>Analyte Name</th>
                                                        <th className="text-center">Current Value</th>
                                                        <th className="text-center">Previous Value 1</th>
                                                        <th className="text-center">Previous Value 2</th>
                                                        <th>Units</th>
                                                        <th className="text-center">Reference Range</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {chunk.map((item, index) => {
                                                        const isNewPanelName = index === 0 || chunk[index].TestOrder !== chunk[index - 1]?.TestOrder;
                                                        return (
                                                            <>
                                                                {isNewPanelName && (
                                                                    <tr className='abnormal-panel-row'>
                                                                        <td colSpan={6}>{item.PanelName}</td>
                                                                    </tr>
                                                                )}

                                                                <tr>
                                                                    <td>{item.AnalyteName}</td>
                                                                   
                                                                    <td
                                                                        className={`text-center ${/[a-zA-Z]/.test(item.Result) ||  
                                                                                (
                                                                                    !isNaN(parseFloat(item.Result.replace(/[^\d.-]/g, ''))) &&
                                                                                    (
                                                                                        parseFloat(item.Result.replace(/[^\d.-]/g, '')) < parseFloat(item.LowerRange) ||
                                                                                        parseFloat(item.Result.replace(/[^\d.-]/g, '')) > parseFloat(item.HigherRange)
                                                                                    )
                                                                                )
                                                                                ? 'fw-bold'
                                                                                : ''
                                                                            }`}
                                                                    >
                                                                        <span
                                                                            className="hover-effect"
                                                                            data-bs-toggle="tooltip"
                                                                            data-bs-placement="top"
                                                                            title={`Lab Number: ${item.LabNumber || '-'}, Result Date: ${item.ResultDate || '-'}`}
                                                                        >
                                                                            {item.Result || '-'}
                                                                        </span>
                                                                    </td>
                                                                  

                                                                    <td className={`text-center ${/[a-zA-Z]/.test(item.PreviousResult1) || (
                                                                                    !isNaN(parseFloat(item.PreviousResult1.replace(/[^\d.-]/g, ''))) &&
                                                                                    (
                                                                                        parseFloat(item.PreviousResult1.replace(/[^\d.-]/g, '')) < parseFloat(item.LowerRange) ||
                                                                                        parseFloat(item.PreviousResult1.replace(/[^\d.-]/g, '')) > parseFloat(item.HigherRange)
                                                                                    )
                                                                                ) ? 'fw-bold' : ''}`}
                                                                    > <span className='hover-effect' data-bs-toggle="tooltip" data-bs-placement="top"
                                                                        title={`Lab Number: ${item.PreviousLabNumber1 || '-'}, Result Date: ${item.PreviousResultDate1 || '-'}`}>
                                                                            {item.PreviousResult1 || '-'}</span></td>

                                                                   

                                                                    <td className={`text-center ${/[a-zA-Z]/.test(item.PreviousResult2) || (
                                                                                    !isNaN(parseFloat(item.PreviousResult2.replace(/[^\d.-]/g, ''))) &&
                                                                                    (
                                                                                        parseFloat(item.PreviousResult2.replace(/[^\d.-]/g, '')) < parseFloat(item.LowerRange) ||
                                                                                        parseFloat(item.PreviousResult2.replace(/[^\d.-]/g, '')) > parseFloat(item.HigherRange)
                                                                                    )
                                                                                ) ? 'fw-bold' : ''}`}
                                                                    > <span className='hover-effect' data-bs-toggle="tooltip" data-bs-placement="top"
                                                                        title={`Lab Number: ${item.PreviousLabNumber2 || '-'}, Result Date: ${item.PreviousResultDate2 || '-'}`}>
                                                                            {item.PreviousResult2 || '-'}</span></td>

                                                                    <td>{item.Units}</td>
                                                                    {/* <td className="text-center">{item.ReferengeRange}</td> */}
                                                                    <td className="text-center">
                                                                        {
                                                                            ((item.ReferengeRange === "" || item.ReferengeRange === " ") && item.LowRange !== "")
                                                                                ? (item.LowRange )
                                                                                : (item.ReferengeRange)
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ))}
        </>
    );
};


export default ReportSummary;
